<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'sub-router'
}
</script>



// WEBPACK FOOTER //
// SubRouter.vue?3f0636b6